import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'relative overflow-hidden px-3 pt-[38px] text-[#003A70] md:h-[750px] md:px-0 md:pt-[68px] lg:h-[628px]',
    video:
      'pointer-events-none absolute top-[172px] left-1/2 -z-2 w-[360px] -translate-x-1/2 rotate-[55deg] md:top-1/2 md:w-[630px] md:-translate-x-[327px] md:-translate-y-[144px] md:rotate-[60deg] lg:rotate-0',
    bgTop:
      'absolute top-[55px] right-0 -z-1 w-[145px] md:top-0 md:left-0 md:w-[20vw] lg:w-[328px]',
    bgBottom:
      'absolute top-[350px] left-0 -z-1 w-60 md:top-[11px] md:right-[-54px] md:left-auto md:w-[30vw] lg:w-[556px]',
    title:
      'relative z-1 mb-4 text-[22px] leading-[1.2] font-medium md:mb-0 md:text-center md:text-[40px]',
    block:
      'group relative z-1 mb-4 max-w-[328px] md:pointer-events-none md:absolute md:mb-0 md:flex md:min-h-28 md:max-w-[496px] md:-translate-y-1/2 md:cursor-pointer md:flex-col md:justify-center md:rounded-full md:bg-white/30 md:backdrop-blur-[10px] md:[transition:max-width_0.2s_ease,min-height_0.2s_ease,padding_0.2s_ease,border-radius_0.2s_ease] md:hover:z-2 md:hover:[transition:max-width_0.5s_ease,min-height_0.5s_ease,padding_0.5s_ease,border-radius_0.5s_ease]',
    wetting:
      'min-h-[241px] md:top-[calc(50%-125px)] md:left-[calc(50%-130px)] md:px-10 md:py-5 md:pl-[116px] lg:top-[calc(50%+153px)] lg:right-[calc(50%+53px)] lg:left-auto lg:max-w-[388px] lg:py-5 lg:pr-[116px] lg:pl-10 lg:hover:max-w-[496px] lg:hover:rounded-[100px_1000px_1000px_100px] xl:top-[calc(50%+135px)] xl:right-[calc(50%+127px)]',
    strengthening:
      'min-h-[116px] md:top-[calc(50%+245px)] md:right-[calc(50%-125px)] md:px-10 md:py-5 md:pr-[116px] lg:top-[calc(50%-50px)] lg:right-auto lg:left-[calc(50%+23px)] lg:max-w-[431px] lg:py-5 lg:pr-10 lg:pl-[116px] lg:hover:max-w-[496px] lg:hover:rounded-[1000px_100px_100px_1000px] xl:top-[calc(50%-30px)] xl:left-[calc(50%+123px)]',
    subtitle:
      'flex h-16 items-center rounded-full bg-white/60 px-5 text-[15px] leading-[1.2] font-medium uppercase shadow-[0_0_20px_rgba(0,0,0,0.05)] backdrop-blur-[10px] md:h-auto md:bg-transparent md:px-0 md:shadow-none md:backdrop-blur-none',
    subtitleWetting: 'pr-5 pl-[68px] md:pr-0 md:pl-0',
    subtitleStrengthening: 'pr-[68px] pl-5 md:pr-0 md:pl-0',
    button:
      'absolute top-2 z-2 flex size-12 items-center justify-center rounded-full bg-[linear-gradient(243.49deg,rgba(212,221,229,0.6)_-21.99%,rgba(255,255,255,0)_116.55%)] md:top-1/2 md:size-[88px] md:-translate-y-1/2 md:bg-none',
    buttonWetting: 'left-2 md:left-3 lg:right-3 lg:left-auto',
    buttonStrengthening: 'right-2 md:right-3 lg:right-auto lg:left-3',
    buttonBg:
      'absolute top-1/2 left-1/2 hidden size-full -translate-1/2 animate-[spin_5s_linear_infinite] md:block',
    buttonInner:
      'relative z-1 flex size-10 items-center justify-center rounded-full bg-white md:size-[72px]',
    hit: 'pointer-events-auto absolute inset-x-0 top-1/2 z-1 hidden h-28 -translate-y-1/2 md:block',
    content:
      'grid transition-[grid-template-rows] duration-200 ease-out md:group-hover:grid-rows-[1fr] md:group-hover:duration-500',
    contentInner: 'overflow-hidden',
    list: 'rounded-[28px] bg-white/60 px-5 py-[18px] pl-[29px] backdrop-blur-[10px] md:bg-transparent md:p-0 md:opacity-0 md:backdrop-blur-none md:transition-opacity md:duration-200 md:group-hover:opacity-100 md:group-hover:duration-[1300ms] lg:w-[300px] xl:w-[340px]',
    ingredient: 'relative pb-2 pl-[21px] last:pb-0',
    ingredientTitle: 'mb-1 text-sm leading-[1.6] font-medium md:mb-0',
    ingredientText: 'text-sm leading-[1.5]'
  },
  variants: {
    open: {
      true: {
        content: 'grid-rows-[1fr]'
      },
      false: {
        content: 'grid-rows-[0fr]'
      }
    }
  }
});
